import React, { Component } from 'react';
import classNames from 'classnames';

export default WithTransition => {
	return class WithTransitionComponent extends Component {
		transitionTimeout = null;
		state = {
			lastActive: null,
			entering: false,
			exiting: false
		};

		static getDerivedStateFromProps(nextProps, prevState) {
			return {
				exiting: prevState.lastActive !== null && prevState.lastActive && !nextProps.active,
				entering: prevState.lastActive !== null && !prevState.lastActive && nextProps.active,
				lastActive: nextProps.active
			};
		}

		render() {
			const { timeout, active, className, ...passThroughProps } = this.props;
			if (!this.transitionTimeout && (this.state.exiting || this.state.entering)) {
				this.transitionTimeout = setTimeout(() => {
					this.setState({ exiting: false, entering: false });
					this.transitionTimeout = null;
				}, timeout || 300);
			}

			const newActive = active || this.state.exiting || this.state.entering;
			const inTransition = this.state.exiting || this.state.entering;

			const mainClass = classNames({
				[className]: className,
				[this.props.classBEMRoot + '--disabled']: this.props.disabled,
				[this.props.classBEMRoot + '--exiting']: this.state.exiting,
				[this.props.classBEMRoot + '--entering']: this.state.entering,
				[this.props.classBEMRoot + '--in-transition']: this.state.exiting || this.state.entering,
				[this.props.classBEMRoot + '--active']: newActive
			});
			return <WithTransition className={mainClass} active={newActive} exiting={this.state.exiting} entering={this.state.entering} inTransition={inTransition} {...passThroughProps} />;
		}
	};
};